import React from 'react';
import { Button, Icon, IconList } from 'components/core';
import { Inline } from 'components/layout';

export type SuggestionActionButtonsProps = {
  suggestionLabel: string;
  // When given, the accessible labels become e.g.
  // "Accept suggestion: USA and enable Country field" — used where accepting
  // or rejecting also swaps a readonly suggestion preview for the editable field.
  fieldLabel?: string;
  size?: React.ComponentProps<typeof Button>['size'];
  onAccept: () => void;
  onReject: () => void;
};

export const SuggestionActionButtons = ({
  suggestionLabel,
  fieldLabel,
  size,
  onAccept,
  onReject,
}: SuggestionActionButtonsProps) => {
  const labelSuffix = fieldLabel ? ` and enable ${fieldLabel} field` : '';

  return (
    <Inline spacing={2}>
      <Button
        iconOnly
        variant="outline"
        type="success"
        size={size}
        htmlType="button"
        aria-label={`Accept suggestion: ${suggestionLabel}${labelSuffix}`}
        onClick={onAccept}
      >
        <Icon icon={IconList.solid.faCheck} />
      </Button>
      <Button
        iconOnly
        variant="outline"
        type="danger"
        size={size}
        htmlType="button"
        aria-label={`Reject suggestion: ${suggestionLabel}${labelSuffix}`}
        onClick={onReject}
      >
        <Icon icon={IconList.solid.faClose} />
      </Button>
    </Inline>
  );
};
